jQuery( function ( $ ) {

  const $banner = $( '#page-title-banner' );
  const $slides = $( '.ptb-content', $banner );

  if ( $slides.length > 1 ) {

    // set banner body color equal to next slide body color
    $banner.on( 'init beforeChange', function ( e, slick, current = null, next = null ) {
      const new_style = getComputedStyle( slick.$slides[ next ?? 0 ] );
      [ '--alt-heading-color', '--subtle-color' ].forEach( prop => {
        this.style.setProperty( prop, new_style.getPropertyValue( prop ) );
      });
    });

    $banner.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      dots: true,
      arrows: false,
      infinite: false,
      mobileFirst: true,
      accessibility: false,
      rows: 0,
      adaptiveHeight: false,
      customPaging: function ( slider, i ) {
        return $('<button>').html( $( '<span>' ).addClass( 'sr-only' ).text( i + 1 ) );
      },
    });
  }

});